import { motion, AnimatePresence } from 'framer-motion';
import { useNetworkStatus } from 'hooks/useNetworkStatus';
import { useTranslation } from 'react-i18next';

const CONFIG = {
  connected: {
    key: 'connectedMode',
    icon: '🟢',
    className: 'network-connected',
    textColor: 'text-emerald',
  },
  degraded: {
    key: 'degradedMode',
    icon: '🟡',
    className: 'network-degraded',
    textColor: 'text-amber',
  },
  offline: {
    key: 'offlineMode',
    icon: '🔴',
    className: 'network-offline',
    textColor: 'text-crimson',
  },
};

export default function NetworkBanner() {
  const status = useNetworkStatus();
  const { t } = useTranslation();
  const cfg = CONFIG[status];

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={status}
        initial={{ opacity: 0, y: -8 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -8 }}
        transition={{ duration: 0.3 }}
        className={`border-b ${cfg.className} px-4 py-1.5 flex items-center justify-center gap-2`}
        role="status"
        aria-live="polite"
      >
        <span className="text-sm">{cfg.icon}</span>
        <span className={`text-xs font-semibold font-mono tracking-wider ${cfg.textColor}`}>
          {t(cfg.key)}
        </span>
        {status !== 'connected' && (
          <span className="ml-2 text-xs text-gray-400">
            {status === 'offline'
              ? 'Data will sync when reconnected'
              : 'Some features may be limited'}
          </span>
        )}
      </motion.div>
    </AnimatePresence>
  );
}
